import React from "react";
import {
  StyledHeaderWrapper,
  StyledHeaderContent,
} from "../styles/styledComponents";

import { ReactComponent as LogoPlannja } from "../assets/images/plannja_logo.svg";
import piriLogo from '../assets/images/Piristeel_logo.png';
import { piristeelTheme, plannjaTheme, ruukkiTheme } from "../styles/themes";
import {useTranslation} from "react-i18next";


type HeaderProps = {
  theme?: any
};

const Header = (props: HeaderProps) => {
 
  const {theme} = props;
  const {t} = useTranslation('trans');

  return (  
    <StyledHeaderWrapper>
      <StyledHeaderContent>
      {theme === plannjaTheme &&    
      <LogoPlannja width="120px" height="100%" />   
      }
      {theme === piristeelTheme &&    
      <img width="300px" alt="Piristeel logo" src={piriLogo} />   
      }
      {theme === ruukkiTheme &&    
      <img width="300px" alt="" src="" />   
      }
        <h1>{t('header.title')}</h1>
        <p>
        {t('header.text')}
        </p>
      </StyledHeaderContent>
    </StyledHeaderWrapper> 
  );
};

export default Header;
